import React, { FunctionComponent } from "react"

interface WYRColorIconProps {}

const WYRColorIcon: FunctionComponent<WYRColorIconProps> = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="10.8" y="1.2002" width="2.4" height="21.6" rx="1.2" fill="#475766"/>
<circle cx="6.44995" cy="6.4502" r="3.75" fill="#1EB482"/>
<circle cx="17.55" cy="17.5498" r="3.75" fill="#1EB482"/>
<circle cx="12" cy="12" r="4.25" fill="#1EB482" stroke="white"/>
</svg>
  )
}

export default WYRColorIcon
